import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestion = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Shape",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.5 0C12.9183 0 16.5 3.58172 16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8C0.5 3.58172 4.08172 0 8.5 0ZM8.5 11C7.94772 11 7.5 11.4477 7.5 12C7.5 12.5523 7.94772 13 8.5 13C9.05229 13 9.5 12.5523 9.5 12C9.5 11.4477 9.05229 11 8.5 11ZM8.4999 3C6.84283 3.00016 5.5 4.10802 5.5 6H7.5C7.5 5.30669 7.87166 5.00006 8.5001 5C9.15208 4.99994 9.5 5.28211 9.5 6C9.5 6.60602 9.41464 6.77751 8.97628 7.091C7.91402 7.85068 7.5 8.93659 7.5 10H9.5C9.5 9.52228 9.68189 9.0452 10.1397 8.7178C11.1113 8.02299 11.5 7.24199 11.5 6C11.5 4.07438 10.1751 2.99984 8.4999 3Z",
			fill: "#1B3380"
		})
	})]
});
const ForwardRef = forwardRef(SvgQuestion);
export { ForwardRef as ReactComponent };
